import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Button } from '@blueprintjs/core';
import ReactMarkdown from 'react-markdown';
import ReactMde from 'react-mde';
import 'react-mde/lib/styles/css/react-mde-all.css';
import * as Showdown from "showdown";
import Toolabr from '../component/Toolbar';



@withRouter
@inject("store")
@observer
export default class BigTitle extends Component
{

     
    constructor(props) {
        super(props);
        const converter = new Showdown.Converter({
            tables: true,
            simplifiedAutoLink: true,
            strikethrough: true,
            tasklists: true
          });
        this.state =  {"selectedTab":"write"};
        this.changefatherstate = this.changefatherstate.bind(this);
        
    }

   
    changefatherstate(){
        this.props.changefatherstate();
    }
   
   
    
    render()
    {

       


        return <div className="notepagebig">
               <div className="titlebox">
               <ReactMarkdown source={this.props.store.current_note_markdown} />
               </div>
              
              <Toolabr changeparentstate = {this.changefatherstate}/>

                <div className="contentbox">
                    { this.props.store.is_editing ?
                    <ReactMde
                         value={this.props.store.current_note_parctise}
                         onChange={md=>this.props.store.current_note_parctise=md}
                        selectedTab={this.state.selectedTab}
                        onTabChange={(tab)=>this.setState({"selectedTab":tab})}
                       
                        l18n={{"write":"编辑","preview":"预览"}}
                        
                        minEditorHeight={700}

                        generateMarkdownPreview={markdown =>
                            Promise.resolve(converter.makeHtml(markdown))
                          }
                        />
                    : 
                    <ReactMarkdown source={this.props.store.current_note_parctise} />
                    }
                    
                </div>
            </div>;
    }
}